import * as React from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 9.54117L18.7454 8L12.0001 13.446L5.2546 8L4 9.54117L12 16L20 9.54117Z", fill: "#3D65AB" }));
export default SvgChevron;
